import { createReducer, on, Action } from "@ngrx/store";

import {
    openRegisterYourInterest,
    resetRegisterYourInterest,
    resetCustomerType,
    setCustomerType,
} from "../actions/register-your-interest.actions";

import {
    RegisterYourInterestState,
    RegisterYourInterestStatus,
    initialRegisterYourInterestState,
} from "../models/register-your-interest.models";

export const REGISTER_YOUR_INTEREST_FEATURE_KEY = "registerYourInterest";

const openRegisterYourInterestReducer = (
    state: RegisterYourInterestState,
): RegisterYourInterestState => ({
    ...state,
    status: RegisterYourInterestStatus.Loading,
});

const resetRegisterYourInterestReducer = (): RegisterYourInterestState => ({
    ...initialRegisterYourInterestState,
});

const setCustomerTypeReducer = (
    state: RegisterYourInterestState,
    action: ReturnType<typeof setCustomerType>,
) => ({
    ...state,
    customerType: action.customerType,
});

const resetCustomerTypeReducer = (
    state: RegisterYourInterestState,
): RegisterYourInterestState => ({
    ...state,
    customerType: undefined,
});

const internalReducer = createReducer(
    initialRegisterYourInterestState,
    on(openRegisterYourInterest, openRegisterYourInterestReducer),
    on(resetRegisterYourInterest, resetRegisterYourInterestReducer),
    on(setCustomerType, setCustomerTypeReducer),
    on(resetCustomerType, resetCustomerTypeReducer),
);

export const registerYourInterestReducer = (
    state: RegisterYourInterestState,
    action: Action,
): RegisterYourInterestState => internalReducer(state, action);
